import React from 'react';
import { Sec, SecTitle, Box, Grp, Kpis, Kpi } from '../styled';
import LoadingML from '@/components/LoadingML';
import { fmtThousand } from '@/utils/comUtil';

// 销售总览：按 demo-开发用.html 结构
//   - 全部购票：5 项 KPI（默认蓝）
//   - VIP 购票：5 项 KPI（橙 #e67e22）
// 数据：
//   overview = state.performSales.overview
//   vip = state.performSales.vip
const SalesOverview = ({ overview, vip, loading }) => {
  const {
    seats = 0,
    buyers = 0,
    birdAmount = 0,
    payable = 0,
    perCap = 0,
    repeatRate = null,
  } = overview || {};
  const {
    vipBuyers = 0,
    vipTickets = 0,
    vipBirdAmount = 0,
    vipPayable = 0,
    vipBirdRate = null,
    vipRepeatRate = null,
  } = vip || {};

  const num = (v) => fmtThousand(v, 0);
  // 金额：原值即元，转为「¥X.X 万」
  const amt = (yuan) => {
    if (!yuan) {
      return '¥0';
    }
    const wan = 10000;
    if (yuan < wan) {
      return `¥${num(yuan)}`;
    }
    const val = Number(yuan) / wan;
    return `¥${fmtThousand(val, 1)} 万`;
  };

  const pct = (v) => (v === null ? '—' : `${(v * 100).toFixed(1)}%`);

  return (
    <Sec>
      <SecTitle>销售总览</SecTitle>
      <Box>
        <LoadingML loading={loading ? 1 : 0}>
          <Grp>
            全部购票<em>台上见实时 + 文广票池 T+1 同步</em>
          </Grp>
          <Kpis>
            <Kpi>
              <div className="l">销量（座位）</div>
              <div className="v">{num(seats)}</div>
            </Kpi>
            <Kpi>
              <div className="l">购票人数</div>
              <div className="v">{num(buyers)}</div>
            </Kpi>
            <Kpi>
              <div className="l">早鸟销售额</div>
              <div className="v">{amt(birdAmount)}</div>
            </Kpi>
            <Kpi>
              <div className="l">应付销售额</div>
              <div className="v">{amt(payable)}</div>
            </Kpi>
            <Kpi>
              <div className="l">人均购票张数</div>
              <div className="v">
                {num(perCap)}
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 400,
                    color: '#8c939e',
                    marginLeft: 2,
                  }}
                >
                  张
                </span>
              </div>
            </Kpi>
            <Kpi>
              <div className="l">复购率</div>
              <div className="v">{pct(repeatRate)}</div>
            </Kpi>
          </Kpis>

          <Grp>
            VIP 购票<em>888 VIP 以下单时点判定</em>
          </Grp>
          <Kpis>
            <Kpi gold>
              <div className="l">VIP 购票人数</div>
              <div className="v">{num(vipBuyers)}</div>
            </Kpi>
            <Kpi gold>
              <div className="l">VIP 购票张数</div>
              <div className="v">{num(vipTickets)}</div>
            </Kpi>
            <Kpi gold>
              <div className="l">VIP 早鸟销售额</div>
              <div className="v">{amt(vipBirdAmount)}</div>
            </Kpi>
            <Kpi gold>
              <div className="l">VIP 应付销售额</div>
              <div className="v">{amt(vipPayable)}</div>
            </Kpi>
            <Kpi gold>
              <div className="l">VIP销售额占比</div>
              <div className="v">{pct(vipBirdRate)}</div>
            </Kpi>
            <Kpi gold>
              <div className="l">复购率</div>
              <div className="v">{pct(vipRepeatRate)}</div>
            </Kpi>
          </Kpis>
        </LoadingML>
      </Box>
    </Sec>
  );
};

export default SalesOverview;
